import { useDesignTabs } from "./hooks/use-design-tabs";

export function useDesignSystemContainer() {
  const tabs = useDesignTabs("colors");
  return { tabs };
}
